module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/185-haiti-99fb0aceefd44ed8c6f095d0305e5588.svg";